export default __webpack_public_path__ + "static/media/repository.ae252258.svg";